import topVolume from './top-volume';
import topBreakout from './top-breakout';
import topNewHigh from './top-newhigh';
import topForeignTrade from './top-foreign-trade';

export default {
  topVolume,
  topBreakout,
  topNewHigh,
  topForeignTrade,
}
